import { Component, ViewContainerRef, OnInit, Input } from '@angular/core';
import { GraphBar } from '../../../_models/graph/GraphBar';
import { BarSegment } from '../../../_models/graph/BarSegment';

@Component({
    selector: 'app-bar',
    templateUrl: './bar.component.html',
    styleUrls: ['./bar.component.css']
})

export class BarComponent implements OnInit{
    
    @Input()
    public bar: GraphBar;

    @Input()
    public tallestBar: number;

    @Input()
    public numberOfBars: number;

    @Input()
    public total: number;

    @Input()
    public colors: string[];

    @Input()
    public isCurrency: boolean;

    public sortedSegments: BarSegment[] = []

    ngOnInit(){
        this.sortedSegments = [...this.bar.segments].sort((a, b) => a.size - b.size)
    }
}